export const createFarmState = () => ({
  farm: null,
  view: 'mine',
  selectedStudent: null,
  loading: true,
  busyKey: null,
  error: '',
  careNotice: '',
  serverOffsetMs: 0,
});

export const serverNow = (state, browserNow = Date.now()) => browserNow + (Number(state.serverOffsetMs) || 0);

export const parseFarmTimestamp = (value) => {
  const timestamp = String(value || '').trim();
  const normalized = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(timestamp)
    ? `${timestamp.replace(' ', 'T')}Z`
    : timestamp;

  return Date.parse(normalized);
};

export const remainingMs = (maturesAt, now) => Math.max(0, parseFarmTimestamp(maturesAt) - now);

export const applyFarmResponse = (state, farm, browserNow = Date.now()) => {
  const serverTimestamp = Date.parse(farm?.serverTime || '');
  const serverOffsetMs = Number.isFinite(serverTimestamp) ? serverTimestamp - browserNow : 0;
  return {
    ...state,
    farm,
    loading: false,
    error: '',
    busyKey: null,
    serverOffsetMs,
  };
};

export const mapFarmError = (error) => {
  const detail = error?.detail
    || error?.errors?.[0]?.detail
    || error?.response?.errors?.[0]?.detail;
  if (detail) return String(detail);

  switch (error?.status ?? error?.response?.status) {
    case 401: return '请先登录后再进入农场。';
    case 403: return '当前账号暂时无法使用农场。';
    case 409: return '当前状态已变化，请刷新后重试。';
    case 422: return '提交内容不完整，请检查后重试。';
    case 429: return '操作过于频繁，请稍后再试。';
    default: return '网络连接失败，请稍后重试。';
  }
};
